import gql from "graphql-tag";
const itilityQueries = {}
const clients = {}
clients.get = gql(` 
query GetClient($id: Number!, $name: String!) {
  getClient(id: $id, name: $name) {
    id
    name
    description
    effectivedate
    status
    createdate
    modifydate
    orgs_id
  } 
}   
`)
clients.list = gql(` 
query getAllClients {
    listClients{
        items{
                name
                description
                effectivedate
                status
        }
    }
}
`)
itilityQueries.clients = clients;

const business = {}
business.get = gql(` 
query GetBusiness($id: Number!, $name: String!) {
  getBusiness(id: $id, name: $name) {
    id
    name
    description
    status
    createdate
    modifydate
    orgs_id
  } 
}   
`)
business.list = gql(` 
query getAllBusiness {
    listBusinesses{
        items{
                name
                description
                status
        }
    }
}
`)
itilityQueries.business = business;


const policies = {}
policies.get = gql(` 
query GetPolicies($id: Number!, $name: String!) {
  getPolicies(id: $id, name: $name) {
    id
    name
    description
    link
    type
    status
    createdate
    modifydate
    orgs_id
  } 
}   
`)
policies.list = gql(` 
query getAllPolicies {
    listPolicies{
        items{
                id
                name
                description
                link
                type
                status
                createdate
                modifydate
                orgs_id
        }
    }
}
`)
itilityQueries.policies = policies;


const procedures = {}
procedures.get = gql(` 
query GetProcedures($id: Number!, $number: String!) {
  getProcedures(id: $id, number: $number) {
    id
    number
    description
    category
    type
    status
    createdate
    modifydate
  } 
}   
`)
procedures.list = gql(` 
query getAllProcedures {
    listProcedures{
        items{
                number
                description
                category
                type
                status
        }
    }
}
`)
itilityQueries.procedures = procedures;


const programs = {}
programs.get = gql(` 
query GetPrograms($id: Number!, $name: String!) {
  getPrograms(id: $id, name: $name) {
    id
    name
    shortname
    description
    sourcing
    effectivedate
    status
    createdate
    modifydate
    orgs_id
  } 
}   
`)
programs.list = gql(` 
query getAllPrograms {
    listPrograms{
        items{
                name
                shortname
                description
                sourcing
                effectivedate
                status
        }
    }
}
`)
itilityQueries.programs = programs;


const instructions = {}
instructions.get = gql(` 
query GetInstructions($id: Number!) {
  getInstructions(id: $id) {
    id
    description
    stage
    status
    createdate
    modifydate
    orgs_id
  } 
}   
`)
instructions.list = gql(` 
query getAllInstructions {
    listInstructions{
        items{
                description
                stage
                status
        }
    }
}
`)
itilityQueries.instructions = instructions;


const groups = {}
groups.get = gql(` 
query GetGroups($id: Number!, $number: String!) {
  getGroups(id: $id, number: $number) {
    id
    number
    effectivedate
    status
    createdate
    modifydate
    orgs_id
    businesslist_id
    clientslist_id
  } 
}   
`)
groups.list = gql(` 
query getAllGroups {
    listGroups{
        items{
                number
                effectivedate
                status
                businesslist_id
                clientslist_id
        }
    }
}
`)
itilityQueries.groups = groups;

export default itilityQueries
